import React from 'react';
import {useNavigate} from "react-router-dom";
import {useAuth} from "context/AuthContext";
import Dropdown, {DropdownItem} from "components/Dropdown";
import {EyeIcon, PencilIcon, TrashIcon} from "@heroicons/react/solid";
import {TrailRating} from "types/TrailRating";

// Types ----

type TrailRatingContextMenuProps = {
  trailRating: TrailRating
  onDeleteTrailRating: () => void
  viewDisabled?: boolean
  editDisabled?: boolean
  deleteDisabled?: boolean
  position?: 'left' | 'right'
}

// Component ----

function TrailRatingContextMenu({trailRating, onDeleteTrailRating, viewDisabled, editDisabled, deleteDisabled, position = 'right'}: TrailRatingContextMenuProps) {
  const navigate = useNavigate();
  const auth = useAuth();

  function viewTrailRating() {
    void navigate(`/trail-ratings/${trailRating.id}`)
  }

  function editTrailRating() {
    void navigate(`/trail-ratings/${trailRating.id}/edit`)
  }

  return (
    <Dropdown position={position}>
      {auth.can('trail-ratings:read') &&
        <DropdownItem name="View" icon={EyeIcon} onClick={viewTrailRating} disabled={!!viewDisabled}/>
      }

      {auth.can('trail-ratings:write') &&
        <DropdownItem name="Edit" icon={PencilIcon} onClick={editTrailRating} disabled={!!editDisabled}/>
      }

      {auth.can('trail-ratings:write') &&
        <DropdownItem name="Delete" icon={TrashIcon} onClick={onDeleteTrailRating} disabled={!!deleteDisabled}/>
      }
    </Dropdown>
  );
}

export default TrailRatingContextMenu;